/**
 * Front-my-End — DOM References Gateway
 *
 * Consolidates all DOM lookup concerns in a single modular dictionary.
 * Uses lazy getters to ensure DOM elements are queried exactly when accessed,
 * preventing eager initialization race conditions.
 */
export const refs = {
  // Editors & Output
  get htmlEditor() { return document.getElementById('html-editor'); },
  get cssEditor() { return document.getElementById('css-editor'); },
  get jsEditor() { return document.getElementById('js-editor'); },
  get htmlOverlay() { return document.getElementById('html-highlight-overlay'); },
  get cssOverlay() { return document.getElementById('css-highlight-overlay'); },
  get jsOverlay() { return document.getElementById('js-highlight-overlay'); },
  get previewIframe() { return document.getElementById('preview-iframe'); },
  get previewWrapper() { return document.querySelector('.preview-viewport-wrapper'); },

  // Selectors
  get viewSelect() { return document.getElementById('view-select'); },
  get menuTemplateSelect() { return document.getElementById('menu-template-select'); },
  get menuThemeSelect() { return document.getElementById('menu-theme-select'); },
  get menuViewSelect() { return document.getElementById('menu-view-select'); },

  // Action Buttons
  get runBtn() { return document.getElementById('run-btn'); },
  get exportBtn() { return document.getElementById('export-btn'); },
  get shareBtn() { return document.getElementById('share-btn'); },
  get resetBtn() { return document.getElementById('reset-btn'); },
  get importBtn() { return document.getElementById('import-btn'); },
  get liveBtn() { return document.getElementById('live-btn'); },
  get inspectBtn() { return document.getElementById('inspect-btn'); },
  get fileInput() { return document.getElementById('file-input'); },

  // Panels
  get panelHtml() { return document.getElementById('panel-html'); },
  get panelCss() { return document.getElementById('panel-css'); },
  get panelJs() { return document.getElementById('panel-js'); },
  get panelPreview() { return document.getElementById('panel-preview'); },
  get panelConsole() { return document.getElementById('panel-console'); },
  get panelScratchpad() { return document.getElementById('panel-scratchpad'); },
  get scratchEditor() { return document.getElementById('scratch-editor'); },
  get consoleOutput() { return document.getElementById('console-output'); },
  get consoleToolbar() { return document.getElementById('console-toolbar'); },
  get consoleCopyBtn() { return document.getElementById('console-copy-btn'); },
  get consoleClearBtn() { return document.getElementById('console-clear-btn'); },

  // Modals & Overlays
  get resetConfirmModal() { return document.getElementById('reset-confirm-modal'); },
  get modalConfirmBtn() { return document.getElementById('modal-confirm-btn'); },
  get modalCancelBtn() { return document.getElementById('modal-cancel-btn'); },
  get messageModal() { return document.getElementById('message-modal'); },
  get messageModalTitle() { return document.getElementById('message-modal-title'); },
  get messageModalBody() { return document.getElementById('message-modal-body'); },
  get messageModalOkBtn() { return document.getElementById('message-modal-ok-btn'); },
  get exportModal() { return document.getElementById('export-modal'); },
  get exportNameInput() { return document.getElementById('export-name-input'); },
  get exportFormatSelect() { return document.getElementById('export-format-select'); },
  get exportCancelBtn() { return document.getElementById('export-cancel-btn'); },
  get exportConfirmBtn() { return document.getElementById('export-confirm-btn'); },
  get previewFrameModal() { return document.getElementById('preview-frame-modal'); },
  get previewFrameProfileSelect() { return document.getElementById('preview-frame-profile-select'); },
  get previewFrameLabelInput() { return document.getElementById('preview-frame-label-input'); },
  get previewFrameWidthInput() { return document.getElementById('preview-frame-width-input'); },
  get previewFrameHeightInput() { return document.getElementById('preview-frame-height-input'); },
  get previewFrameDprInput() { return document.getElementById('preview-frame-dpr-input'); },
  get previewFrameNote() { return document.getElementById('preview-frame-note'); },
  get previewFrameError() { return document.getElementById('preview-frame-error'); },
  get previewFrameCancelBtn() { return document.getElementById('preview-frame-cancel-btn'); },
  get previewFrameSwapBtn() { return document.getElementById('preview-frame-swap-btn'); },
  get previewFrameApplyBtn() { return document.getElementById('preview-frame-apply-btn'); },
  get shareModal() { return document.getElementById('share-modal'); },
  get shareTitleInput() { return document.getElementById('share-title-input'); },
  get shareModeSelect() { return document.getElementById('share-mode-select'); },
  get shareLinkOutput() { return document.getElementById('share-link-output'); },
  get shareLinkField() { return document.getElementById('share-link-field'); },
  get shareChallenge() { return document.getElementById('share-challenge'); },
  get shareChallengeStatus() { return document.getElementById('share-challenge-status'); },
  get shareCancelBtn() { return document.getElementById('share-cancel-btn'); },
  get shareCopyBtn() { return document.getElementById('share-copy-btn'); },
  get shareCreateBtn() { return document.getElementById('share-create-btn'); },
  get dropOverlay() { return document.getElementById('drop-overlay'); },

  // Menu
  get menuBtn() { return document.getElementById('menu-btn'); },
  get mobileContextFab() { return document.getElementById('mobile-context-fab'); },
  get quickMenuDropdown() { return document.getElementById('quick-menu-dropdown'); },
  get menuRunBtn() { return document.getElementById('menu-run-btn'); },
  get menuExportBtn() { return document.getElementById('menu-export-btn'); },
  get menuShareBtn() { return document.getElementById('menu-share-btn'); },
  get menuResetBtn() { return document.getElementById('menu-reset-btn'); },
  get menuImportBtn() { return document.getElementById('menu-import-btn'); },
  get menuScratchBtn() { return document.getElementById('menu-scratch-btn'); },
  get menuMinimizeAllBtn() { return document.getElementById('menu-minimize-all-btn'); },
  get menuRestoreAllBtn() { return document.getElementById('menu-restore-all-btn'); },
  get menuPrivacyBtn() { return document.getElementById('menu-privacy-btn'); },
  get menuTermsBtn() { return document.getElementById('menu-terms-btn'); },
  get menuDocsBtn() { return document.getElementById('menu-docs-btn'); },
  get menuAboutBtn() { return document.getElementById('menu-about-btn'); },

  // Tabs
  tabs: {
    get html() { return document.getElementById('tab-html'); },
    get css() { return document.getElementById('tab-css'); },
    get js() { return document.getElementById('tab-js'); },
    get preview() { return document.getElementById('tab-preview'); },
    get console() { return document.getElementById('tab-console'); },
  }
};
